export function calcDiff(wgsIndicators, dnaIndicators) {
  const num = parseInt(wgsIndicators) - parseInt(dnaIndicators)

  if (!isNaN(num)) {
    return num
  }

  return null
}

export function calcDnaBarWidth(wgsIndicators, dnaIndicators) {
  const dnaNum = parseInt(dnaIndicators)
  const wgsNum = parseInt(wgsIndicators)

  if (!isNaN(dnaNum) && !isNaN(wgsNum) && wgsNum !== 0) {
    return (dnaNum / wgsNum) * 100
  }

  return 0
}
